// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* iOS Safe Area 변수 정의 */
html {
  --safe-area-inset-top: env(safe-area-inset-top, 0px);
  --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);
  --safe-area-inset-left: env(safe-area-inset-left, 0px);
  --safe-area-inset-right: env(safe-area-inset-right, 0px);
}

body {
  margin: 0;
  font-family: 'Pretendard-Regular', 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 전체 앱을 Safe Area만큼 아래로 이동 */
  padding-top: env(safe-area-inset-top, 0px);
}

#root {
  min-height: calc(100vh - env(safe-area-inset-top, 0px));
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
  monospace;
}

/* 색상 (고객 직접 지정) */
:root {
  --main-blue-color: #1C6DFF;
  --main-softblue-color: #4C9AFF;
  --main-white-color: #F5F5F5;
  --sub-darkblue-color: #004DA9;
  --sub-orange-color: #FDA300;
  --sub-mediumgrey-color: #D3D3D3;
  --sub-darkgrey-color: #5B5B5B;
  --sub-excel-color :#1D6F42;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,oDAAoD;EACpD,0DAA0D;EAC1D,sDAAsD;EACtD,wDAAwD;AAC1D;;AAEA;EACE,SAAS;EACT;;YAEU;EACV,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;WACS;AACX;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;AAC5B","sourcesContent":["/* iOS Safe Area 변수 정의 */\r\nhtml {\r\n  --safe-area-inset-top: env(safe-area-inset-top, 0px);\r\n  --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);\r\n  --safe-area-inset-left: env(safe-area-inset-left, 0px);\r\n  --safe-area-inset-right: env(safe-area-inset-right, 0px);\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: 'Pretendard-Regular', 'Segoe UI', 'Roboto', 'Oxygen',\r\n  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n  sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  /* 전체 앱을 Safe Area만큼 아래로 이동 */\r\n  padding-top: env(safe-area-inset-top, 0px);\r\n}\r\n\r\n#root {\r\n  min-height: calc(100vh - env(safe-area-inset-top, 0px));\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n  monospace;\r\n}\r\n\r\n/* 색상 (고객 직접 지정) */\r\n:root {\r\n  --main-blue-color: #1C6DFF;\r\n  --main-softblue-color: #4C9AFF;\r\n  --main-white-color: #F5F5F5;\r\n  --sub-darkblue-color: #004DA9;\r\n  --sub-orange-color: #FDA300;\r\n  --sub-mediumgrey-color: #D3D3D3;\r\n  --sub-darkgrey-color: #5B5B5B;\r\n  --sub-excel-color :#1D6F42;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
